import { render, staticRenderFns } from "./basicPersonnelModule.vue?vue&type=template&id=53215f8a&scoped=true&"
import script from "./basicPersonnelModule.vue?vue&type=script&lang=js&"
export * from "./basicPersonnelModule.vue?vue&type=script&lang=js&"
import style0 from "./basicPersonnelModule.vue?vue&type=style&index=0&id=53215f8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53215f8a",
  null
  
)

export default component.exports